'use client';

import { useEffect } from 'react';

import { bloomreachPixelSendCategoryView } from '../../../../../../modules/analytics/bloomreach/BloomreachPixel/sendBloomreachPageViewTrackingEvent';
import { checkBrEnv } from '../../../../../../modules/analytics/bloomreach/BloomreachPixel/helpers/checkBrEnv';

interface Props {
    conditionId: number;
}

/**
 * Bloomreach tracking pixel for condition pages.
 */
const ConditionPageBloomreachPixel = ({ conditionId }: Props) => {
    useEffect(() => {
        // If bloomreach is not enabled then we don't want to do anything.
        if (checkBrEnv() === false) {
            return;
        }

        bloomreachPixelSendCategoryView({
            cat: `home|${window.location.pathname.replace('/', '')}`,
            cat_id: conditionId.toString(),
        });
    }, [conditionId]);

    return null;
};

export default ConditionPageBloomreachPixel;
